module.exports = __webpack_public_path__ + "static/media/pedro.9ed6297e.gif";